import type { Filters } from '../../table/filters/filters';

const isFilterRecord = (value: unknown): value is Filters =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const toInventoryInterfaceFilter = (filter: Filters): Filters => {
  const result: Filters = {};
  for (const [key, value] of Object.entries(filter)) {
    if ((key === 'and' || key === 'or') && Array.isArray(value)) {
      result[key] = value
        .filter(isFilterRecord)
        .map(toInventoryInterfaceFilter);
      continue;
    }
    result[key === 'intDscr' ? 'dscr' : key] = value;
  }
  return result;
};
